import { ActionType, createAction } from 'typesafe-actions'

import { DomainType, DomainData, State, Town } from './types'

export const DomainsActions = {
  loadDomains: createAction('DOMAINS/load-domains')<{
    domainTypes: DomainType[]
    language: string
    adminxCall?: boolean
  }>(),
  setDomainData: createAction('DOMAINS/set-data')<{ domainType: DomainType; data: DomainData[]; language: string }>(),
  loadStates: createAction('DOMAINS/load-states')<{ countryCode: string; language: string }>(),
  loadTowns: createAction('DOMAINS/load-towns')<{ countryCode: string; stateCode: string; language: string }>(),
  setStates: createAction('DOMAINS/set-states')<{ countryCode: string; data: State[]; language: string }>(),
  setTowns: createAction('DOMAINS/set-towns')<{ stateCode: string; data: Town[]; language: string }>()
}

export type DomainsActions = ActionType<typeof DomainsActions>
